// extracted by mini-css-extract-plugin
export default {"header":"styles_header__ZAfgG","body":"styles_body__EWsAo","numerator":"styles_numerator__J1dHp","line":"styles_line__H-8r4"};